import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

type HeaderProps = {
  onDownloadClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

const Header: React.FC<HeaderProps> = ({ onDownloadClick }) => {
  const [logoError, setLogoError] = useState(false);
  const [scrolled, setScrolled] = useState(false);


  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className="fixed w-full top-0 z-50 transition-all duration-500"
      style={{
        background: scrolled
          ? 'rgba(8, 12, 11, 0.85)'
          : 'transparent',
        backdropFilter: scrolled ? 'blur(24px)' : 'none',
        WebkitBackdropFilter: scrolled ? 'blur(24px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : '1px solid transparent',
      }}
    >
      <div className="container mx-auto">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 font-semibold text-white text-lg group">
            {logoError ? (
              <div className="h-9 w-9 rounded-xl bg-gradient-to-br from-[#68C1AE] to-[#3d8f7e] flex items-center justify-center text-[#080C0B] font-bold">W</div>
            ) : (
              <img
                src="/images/App Icon.jpg"
                alt="Watchi"
                className="h-9 w-9 rounded-xl object-cover ring-1 ring-white/10"
                onError={() => setLogoError(true)}
              />
            )}
            <span className="gradient-text font-bold tracking-tight">Watchi</span>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
            <a href="#features" className="text-white/60 hover:text-white transition-colors duration-200">Features</a>
            <a href="#gallery" className="text-white/60 hover:text-white transition-colors duration-200">Gallery</a>
            <a href="#faq" className="text-white/60 hover:text-white transition-colors duration-200">FAQ</a>
          </nav>

          <div className="flex items-center gap-3">
            <Link to="/privacy" className="hidden md:inline text-white/40 hover:text-white/70 text-sm transition-colors">Privacy</Link>
            <a
              href="https://apps.apple.com/us/app/watchi-watch-faces-gallery/id6753596004"
              className="btn-primary text-sm py-2.5 px-5"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              Get Watchi
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;